import casesAPI from '@/api/resources/cases'
import CrudAPI from '@/api/resources/crud'
import _ from 'lodash'
import moment from 'moment'

const state = {
  onBoardClientForm: {
    forms_id: 1,
    cases_id: null,
    answer: {
      form_name: 'OnBoard Client',
      form_answers: {
        main_form: {
          deceased_date: moment().format('YYYY-MM-DD').toString(),
          deceased_invoice_no: null,
          deceased_name: null,
          deceased_gender: null,
          deceased_name_chinese: null,
          deceased_age: null,
          deceased_death_certificate_no: null,
          deceased_religion: null,
          deceased_dialect: null,
          deceased_days_of_wake: null,
          deceased_location_of_wake: null,
          deceased_burial_location: null,
          deceased_embalming: null
        },
        agreement_form_data: {
          no_valuable_items: false,
          ash_placement_arranged_by: null,
          no_additional_items_on_body: false,
          ashes_placement_agreement: false,
          valuable_items_declaration: '',
          valuable_additional_items_declaration: ''
        },
        client_form_data: {
          relationship_with_deceased: null,
          signature: null,
          date: null,
          email: null,
          contact_number: null,
          name: null,
          nric_fin_number: null
        }
      }
    }
  },
  feedbackForm: {
    id: null,
    forms_id: 2,
    cases_id: null,
    answer: {
      dateStart: moment().format('YYYY-MM-DD'),
      timeStart: moment().format('HH:mm'),
      familyAssembleTime: null,
      funeralServiceCommencedTime: null,
      cortegeLeaveTime: null,
      selectedUser: null,
      funeralRites: null,
      churchLocation: null,
      churchMassAt: null,
      drivingPass: null,
      cremationTime: null,
      cremationLocation: null,
      postFuneralSendTo: null,
      ashCollection: null,
      ashCollectionDate: null,
      ashCollectionTime: null,
      sendAshTo: null,
      sendAshToDate: null,
      sendAshToTime: null,
      seaBurialAt: null,
      seaBurialAtDate: null,
      seaBurialAtTime: null,
      tentageAfter: null,

      addOnServices: [],

      satisfiedWithSetUp: null,
      satisfiedWithSetUpWhy: null,
      satisfiedWithCatering: null,
      satisfiedWithCateringWhy: null,
      satisfiedWithNightService: null,
      satisfiedWithNightServiceWhy: null,
      satisfiedWithInformationProvided: null,
      satisfiedWithInformationProvidedWhy: null
    }
  },
  lastOnBoardForm: null,
  lastFeedbackForm: null,
  caseForms: [],
  editable: false,
  loadingCaseForms: true
}

const getters = {
  getLoadingFormsStatus: state => state.loadingCaseForms,
  getCaseForms: state => state.caseForms,
  isOnBoardClientFormAnswersEditable: state => state.editable,
  getOnBoardClientForm: state => state.onBoardClientForm,
  getOnBoardClientFormAnswers: state => state.onBoardClientForm.answer.form_answers,
  getFeedbackClientForm: state => state.feedbackForm,

  getLastOnBoardForm: state => state.lastOnBoardForm,
  getLastFeedbackForm: state => state.lastFeedbackForm
}

const actions = {
  loadCaseForms ({ state, commit }, caseModel) {
    state.loadingCaseForms = true
    return new Promise((resolve, reject) => {
      state.onBoardClientForm.cases_id = caseModel.id
      state.feedbackForm.cases_id = caseModel.id
      commit('receiveCaseForms', caseModel)
      resolve()
    })
  },
  storeOnBoardForm ({ state, commit }) {
    return new Promise((resolve, reject) => {
      CrudAPI.dfsResourceStore('answers', state.onBoardClientForm).then(result => {
        resolve(result)
      }, () => {})
    })
  },
  storeFeedbackForm ({ state, commit }) {
    return new Promise((resolve, reject) => {
      if (state.feedbackForm.id !== undefined) {
        CrudAPI.dfsResourceUpdate('answers', state.feedbackForm.id, state.feedbackForm).then(result => {
          resolve(result)
        }, () => {})
      } else {
        CrudAPI.dfsResourceStore('answers', state.feedbackForm).then(result => {
          resolve(result)
        }, () => {})
      }
    })
  },
  clearCaseForms ({ commit }) {
    commit('clearCaseForms')
  },
  loadPdfFeedback ({ commit }, answersId) {
    return new Promise((resolve, reject) => {
      casesAPI.loadPDFFeedback(answersId).then((result) => {
        resolve(result)
      })
    })
  }
}

const mutations = {
  receiveCaseForms (state, caseForms) {
    if (caseForms && caseForms.answers && caseForms.answers.length > 0) {
      state.caseForms = _.sortBy(caseForms.answers, 'created_at').reverse()
      state.editable = true

      state.lastOnBoardForm = _.find(state.caseForms, f => f.form.name === 'OnBoardClient')
      state.lastFeedbackForm = _.find(state.caseForms, f => f.form.name === 'Feedback')

      if (state.lastOnBoardForm) state.onBoardClientForm.answer.form_answers = JSON.parse(state.lastOnBoardForm.answer).form_answers
      if (state.lastFeedbackForm) {
        state.feedbackForm = state.lastFeedbackForm
        state.feedbackForm.answer = JSON.parse(state.lastFeedbackForm.answer)
      }
    }
    state.loadingCaseForms = false
  },
  updateMainOnBoardForm (state, mainForm) {
    state.onBoardClientForm.answer.form_answers.main_form = mainForm
  },
  updateAgreementOnBoardForm (state, agreementFormData) {
    state.onBoardClientForm.answer.form_answers.agreement_form_data = agreementFormData
  },
  updateClientOnBoardForm (state, clientFormData) {
    state.onBoardClientForm.answer.form_answers.client_form_data = clientFormData
  },
  updateFeedbackForm (state, feedbackFormAnswers) {
    state.feedbackForm.answer = feedbackFormAnswers
  },
  clearCaseForms (state) {
    state.caseForms = []
    state.onBoardClientForm = {
      forms_id: 1,
      cases_id: null,
      answer: {
        form_name: 'OnBoard Client',
        form_answers: {
          main_form: {
            deceased_date: moment().format('YYYY-MM-DD').toString(),
            deceased_invoice_no: null,
            deceased_name: null,
            deceased_gender: null,
            deceased_name_chinese: null,
            deceased_age: null,
            deceased_death_certificate_no: null,
            deceased_religion: null,
            deceased_dialect: null,
            deceased_days_of_wake: null,
            deceased_location_of_wake: null,
            deceased_burial_location: null,
            deceased_embalming: null
          },
          agreement_form_data: {
            no_valuable_items: false,
            ash_placement_arranged_by: null,
            no_additional_items_on_body: false,
            ashes_placement_agreement: false,
            valuable_items_declaration: '',
            valuable_additional_items_declaration: ''
          },
          client_form_data: {
            relationship_with_deceased: null,
            signature: null,
            date: null,
            email: null,
            contact_number: null,
            name: null,
            nric_fin_number: null
          }
        }
      }
    }
    state.editable = false
    state.loadingCaseForms = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/caseForms.js